module.exports = __webpack_public_path__ + "static/media/charan.166a94f1.jpeg";